<template>
  <div @click="selectCheckpoint" role="listitem" class="item">
    <div class="content">
      <a href="#">{{ checkpoint.task | decodeHTML }}</a>
    </div>
  </div>
</template>

<script>
function DecodeHTML(value){
  var txt = document.createElement("textarea");
  txt.innerHTML = value;
  return txt.value;

}
import { mapMutations } from 'vuex';
export default {
  name: 'task-item',
  props: ["checkpoint", "checkpointId"],
  filters: {
    decodeHTML: DecodeHTML
  },
  methods: {
    selectCheckpoint() {
      this.$store.commit('selectCheckpoint', this.checkpointId);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/CardCheckpoint.vue